import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);
import VueSweetalert2 from "vue-sweetalert2";
import axios from 'axios'
Vue.prototype.$http = axios

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
